<div class="{{ theme$ | async }}">
  @if (loading) {
    <div
      style="
        width: 100%;
        height: 320px;
        background-color: var(--card);
        flex: 1;
        justify-content: center;
        justify-items: center;
      "
    >
      <div style="left: 45%; top: 47%; position: absolute">{{ 'COMMON.LOADING' | translate }}</div>
    </div>
  }
  @if (!loading) {
    <div class="w-100">
      <div class="row pt-2">
        @if (availabilitySelected) {
          <div style="display: flex; justify-content: space-around; margin-top: 5px; margin-bottom: 5px; width: 100%">
            <span class="legend-1">
              <span class="dot-1"></span>
              {{ availabilitySelected ? availabilitySelected?.label : '' }}
            </span>
            <span class="legend-2">
              <span class="dot-2"></span>
              {{
                availabilitySelected
                  ? availabilitySelected?.label + ' (' + ('KPI.SUMMARY.ACCUMULATED' | translate) + ')'
                  : ''
              }}
            </span>
            @if (availabilitySelected?.index === 0 || contractualTarget >= 0) {
              <span class="legend-3">
                <span class="solid-legend"></span>
                {{ availabilitySelected ? availabilitySelected?.label : '' }}
                {{
                  availabilitySelected?.index === 0 || contractualTarget >= 0
                    ? '(' + ('COMMON.TARGET' | translate) + ')'
                    : lastYear
                }}
              </span>
            }
          </div>
        }
      </div>
      @if (data) {
        <div>
          <highcharts-chart
            [id]="chartId"
            class="w-100 d-block"
            [Highcharts]="highcharts"
            [options]="chartOptions"
            [callbackFunction]="chartCallback"
          ></highcharts-chart>
        </div>
      }
    </div>
  }
</div>
